import createDocumentResource from 'src/actions/shared/createDocumentResource';
import emptyObserverCreator from 'src/actions/shared/emptyObserverCreator';
import { IsNotEmpty, IsNumber, IsString } from 'class-validator';
import { logout } from 'src/actions/auth/authSlice';
import * as sharedTypes from 'src/actions/shared/sharedTypes';
import { toastError } from 'src/actions/toast';
import { translateErrors } from 'src/adapters/validateType';
import { Unauthorized, DomainError as StandardDomainError, RequestTimeout } from '@ad-scripts/application/lib/error';

export class LookupDebuggerBasic {
  integrationId: string;
  request: Request;
  response: LookupDebugResponse;
  validationErrors: [];
}

export class Request {
  @IsString()
  @IsNotEmpty()
  url: string;
  payload: {
    lookupLevel: string;
    query: {
      [k: string]: string;
    };
  };
}

export class LookupDebugResponse {
  adapterError: any;
  @IsNumber()
  @IsNotEmpty()
  statusCode: string;
  rawResponse: string;
  payload: {
    results: LookupResults[];
  };
}

export class LookupResults {
  address?: string;
  customAttributes?: Object;
  emails?: EmailAddress[];
  externalCustomerId: string;
  name?: string;
  phones?: PhoneNumber[];
}

export class EmailAddress {
  original: string;
  primary?: Boolean;
}
export class PhoneNumber {
  original: string;
  normalized?: string;
  label?: string;
  primary?: Boolean;
  type: string;
}

export const lookupDebuggerBasicResource = createDocumentResource<LookupDebuggerBasic>({
  name: 'debugBasicLookup',
  endpoint: '/v1/orgs/:orgId/external-customer-lookup/integrations/:integrationId/debug-info',
  type: LookupDebuggerBasic,
  observerCreator: emptyObserverCreator,
  reducers: {
    fetchStarted(state) {
      state.loadingState = 'loading';
    },
    fetchSuccess(state, action) {
      state.loadingState = 'succeeded';
      state.value = action.payload;
    },
    fetchError(state, action) {
      state.loadingState = 'failed';
      state.errors = action.payload;
    },
    fetchRequestError(state, action) {
      state.loadingState = 'failed';
      state.errors = action.payload;
    },
    reset(state) {
      state.loadingState = 'unstarted';
      state.value = {};
      state.errors = [];
    },
    timeoutError(state) {
      state.loadingState = 'failed';
      state.errors = [{ code: 'timeout' }];
    },
  },
  initialValue: {},
});

const fetchBasicDebugging: sharedTypes.AppThunk =
  (urlParams, basicDebuggingSearchAttr) =>
  async (dispatch, getState, { gateways }) => {
    try {
      dispatch(lookupDebuggerBasicResource.actions.fetchStarted({}));
      const result = await gateways.basicLookupDebugging.fetchBasicDebugging(urlParams, basicDebuggingSearchAttr);
      dispatch(lookupDebuggerBasicResource.actions.fetchSuccess(result));
    } catch (err) {
      dispatch(toastError(`There was an error fetching debug data.`));
      if (err instanceof StandardDomainError) {
        dispatch(lookupDebuggerBasicResource.actions.fetchError(translateErrors(err.errors)));
      } else if (err instanceof RequestTimeout) {
        dispatch(lookupDebuggerBasicResource.actions.timeoutError({}));
      } else if (err instanceof Unauthorized) {
        dispatch(logout());
      } else {
        dispatch(lookupDebuggerBasicResource.actions.fetchRequestError(translateErrors((err as any).errors)));
      }
    }
  };

const unload: sharedTypes.AppThunk = () => dispatch => {
  dispatch(lookupDebuggerBasicResource.actions.reset({}));
};

lookupDebuggerBasicResource.effects.fetchBasicDebugging = fetchBasicDebugging;
lookupDebuggerBasicResource.effects.unload = unload;

export default lookupDebuggerBasicResource;
